import { render, staticRenderFns } from "./editUpload.vue?vue&type=template&id=3bc1069e&scoped=true&"
import script from "./editUpload.vue?vue&type=script&lang=js&"
export * from "./editUpload.vue?vue&type=script&lang=js&"
import style0 from "./editUpload.vue?vue&type=style&index=0&id=3bc1069e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc1069e",
  null
  
)

export default component.exports